export default __webpack_public_path__ + "static/media/tree18.5d1f8249.png";